export enum SafeLanguages {
    es_es = 'es_es',
    pt_br = 'pt_br',
    en_us = 'en_us',
}

export enum Location {
    pt_br = 'BRL',
    es_es = 'EUR',
    en_us = 'USD',
}
